var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCertificateValid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 33"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m12.562 20.824-3.728-3.863a1.037 1.037 0 0 0-1.515 0 1.137 1.137 0 0 0 0 1.57l4.49 4.653a1.044 1.044 0 0 0 1.516 0L24.69 11.405a1.138 1.138 0 0 0 0-1.57 1.038 1.038 0 0 0-1.515 0L12.562 20.825Z"
})));
export default SvgCertificateValid;